import { PaymentTypeAll } from '@insurance/api/requests'
import { SelectProps } from 'antd'
import { TFunction } from 'i18next'
export const typeList = Object.values(PaymentTypeAll)
export const typeOptions = (
  t: TFunction,
  includeTypes?: PaymentTypeAll[]
): SelectProps['options'] => {
  const filteredTypeList = includeTypes
    ? typeList.filter((type) => includeTypes.includes(type))
    : typeList

  return filteredTypeList.map((value) => ({
    label: t(value),
    value
  }))
}
